import { render, staticRenderFns } from "./VerifyLoginGoogle.vue?vue&type=template&id=45c6e8fc"
import script from "./VerifyLoginGoogle.vue?vue&type=script&lang=js"
export * from "./VerifyLoginGoogle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports